export interface NominatimResponse {
  state: any
  address: any
  place_id: number
  licence: string
  osm_type: string
  osm_id: number
  lat: string
  lon: string
  class: string
  type: string
  place_rank: number
  importance: number
  addresstype: string
  name: string
  display_name: string
  boundingbox: string[]
}

export const fetchLocation = async (plz: string): Promise<NominatimResponse> => {
  const response = await fetch(`/api/nominatim?q=${encodeURIComponent(plz)}`)
  const data = await response.json() // Parse the ReadableStream
  if (data.length === 0) {
    throw new Error("No location found")
  } else if (data.length > 1) {
    throw new Error("Multiple locations found")
  }
  return data[0]
  // return response.json();
}

/*
 * Calculates the Haversine distance between two geographical points.
 * @param {Object} point1 - The first point with latitude and longitude.
 * @param {Object} point2 - The second point with latitude and longitude.
 * @return {number} - The distance in kilometers between the two points.
 */
export const haversineDistance = (
  { lat1, lon1 }: { lat1: number; lon1: number },
  { lat2, lon2 }: { lat2: number; lon2: number }
): number => {
  const toRad = (deg: number) => (deg * Math.PI) / 180
  const R = 6371 // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c // Distance in km
}
export const parseCoordinates = (value: unknown): number => {
  if (typeof value === "string") {
    const num = parseFloat(value)
    return isNaN(num) ? 0 : num // Fallback to 0 if conversion fails
  }
  return typeof value === "number" ? value : 0
}
